// Helper to detect if running on the server
export const isSSR = typeof window === 'undefined';
